import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/layout/PageHeader";
import { FleetGrid } from "@/components/fleet/FleetGrid";
import { CtaBand } from "@/components/layout/CtaBand";
import { Reveal } from "@/components/motion/Reveal";

export default function ParcoMezzi() {
  return (
    <>
      <Seo title="Parco Mezzi" description="Tutti i mezzi a noleggio DESP a Catania: escavatori Wacker Neuson, dumper, minipala Gehl, piattaforme a forbice Genie e JCB, piattaforme autocarrate Oil&Steel fino a 24 m." path="/parco-mezzi" />
      <PageHeader
        eyebrow="Parco mezzi"
        lines={["Il parco mezzi", "DESP."]}
        description="Mezzi compatti per il movimento terra e piattaforme aeree fino a 24 metri. Filtra per categoria e apri la scheda tecnica di ogni mezzo."
        crumbs={[{ label: "Parco Mezzi" }]}
        image="/images/hero.jpg"
      />
      <section className="bg-white py-16 sm:py-24" data-testid="fleet-section">
        <div className="container-x">
          <FleetGrid />
          <Reveal className="mt-14 border-l-2 border-blue-600 bg-paper p-6 text-sm text-ink/60">
            <p>I dati tecnici indicati sono indicativi e riferiti alle schede ufficiali dei costruttori. Per configurazioni specifiche o accessori, contattaci.</p>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
